module.exports = __webpack_public_path__ + "img/lines_element_blue.b201b452.svg";